import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2Icon, BookOpenIcon, CalendarIcon, ShoppingCartIcon, MoonIcon, AlertTriangleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-8 h-8 text-brand-terracotta" data-id="element-162" />,
    title: 'Guía Principal Menopausia Sin Tabú',
    desc: 'El manual paso a paso para entender y dominar tus hormonas.'
  }, {
    icon: <CalendarIcon className="w-8 h-8 text-brand-amber" data-id="element-163" />,
    title: 'Protocolo de 7 Días',
    desc: 'El plan de comidas exacto para apagar los sofocos desde la primera semana.'
  }, {
    icon: <ShoppingCartIcon className="w-8 h-8 text-brand-sage" data-id="element-164" />,
    title: 'Lista de Compras USA',
    desc: "Marcas y productos específicos 'aprobados' en supermercados comunes."
  }, {
    icon: <MoonIcon className="w-8 h-8 text-brand-terracotta" data-id="element-165" />,
    title: 'El Ritual de la Noche Serena',
    desc: 'Pasos exactos para bajar tu temperatura y dormir 7 horas seguidas.'
  }, {
    icon: <AlertTriangleIcon className="w-8 h-8 text-brand-amber" data-id="element-166" />,
    title: 'Protocolo de Emergencia 3 AM',
    desc: 'Qué hacer exactamente cuando te despiertas para volver a dormir en minutos.'
  }];
  return <SectionWrapper data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brand-brown mb-12" data-id="element-169">
          Lo que obtienes hoy
        </h2>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-16" data-id="element-170">
          {items.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-surface flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-171">
              <div className="mb-4 bg-brand-sand p-4 rounded-full" data-id="element-172">
                {item.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-brand-brown mb-3" data-id="element-173">
                {item.title}
              </h3>
              <p className="font-sans text-brand-brown/80 leading-relaxed" data-id="element-174">
                {item.desc}
              </p>
            </div>)}
        </div>

        <CtaButton onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-175">
          ¡QUIERO EMPEZAR MI PROTOCOLO DE 7 DÍAS YA!
        </CtaButton>
      </div>
    </SectionWrapper>;
}